import { TotalReturnsRowNames } from '../total-returns-table/total-returns-table.model';
import { Constants as TotalReturnsConstants } from '../total-returns/total-returns.constants';

export const Constants = {
  TAG_NAME: 'pop-calendar-year-table-component',
  EMPTY_CELL_VALUE: 'N/A',
} as const;

export const RowHeaders: TotalReturnsRowNames = {
  PureGross: TotalReturnsConstants.PURE_GROSS,
  PureGrossFixedIncome: TotalReturnsConstants.PURE_GROSS_FIXED_INCOME,
  Net: TotalReturnsConstants.NET,
  NetFixedIncome: TotalReturnsConstants.NET_FIXED_INCOME,
  Benchmark: TotalReturnsConstants.BENCHMARK,
  ValuePureGross: TotalReturnsConstants.VALUE_PURE_GROSS,
  ValueNet: TotalReturnsConstants.VALUE_NET,
} as const;
